import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Briefcase, HeartCrack, Frown } from 'lucide-react';
const painPoints = [{
  icon: Briefcase,
  title: 'Estrés y Trabajo Duro',
  desc: 'Vivir en Estados Unidos es estresante. Trabajas turnos largos y comes lo primero que encuentras en el supermercado.'
}, {
  icon: HeartCrack,
  title: 'Sistema de Salud Frío',
  desc: 'El sistema de salud aquí no te enseña a comer, solo te receta pastillas y te prohíbe tus comidas favoritas.'
}, {
  icon: Frown,
  title: 'Culpa en la Mesa',
  desc: 'Es frustrante sentarte a la mesa y sentir culpa por comer un taco, una arepa o un plato de arroz con frijoles.'
}, {
  icon: Clock,
  title: 'Miedo al Futuro',
  desc: "Ver cómo tu energía desaparece a las 3 de la tarde mientras te invade ese miedo silencioso: '¿Y si me enfermo y no puedo trabajar?'"
}];
export function PainAgitation() {
  return <section className="py-20 bg-cream" data-id="element-131">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-133">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-cream-dark flex items-start" data-id="element-134">
              <div className="bg-alert/10 p-3 rounded-lg mr-4 flex-shrink-0" data-id="element-135">
                <point.icon className="w-6 h-6 text-alert" data-id="element-136" />
              </div>
              <div data-id="element-137">
                <h3 className="text-xl font-bold text-forest-dark mb-2" data-id="element-138">
                  {point.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-139">{point.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto text-center" data-id="element-140">
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6" data-id="element-141">
            Has intentado dietas americanas de ensaladas insípidas y pollo
            hervido, pero nadie aguanta eso.
          </p>
          <p className="text-xl md:text-2xl font-bold text-forest" data-id="element-142">
            Tu genética latina no necesita menos sabor, necesita más ciencia
            aplicada a nuestras raíces.
          </p>
        </motion.div>
      </div>
    </section>;
}